import ScrollView from "../../components/ScrollView/ScrollView"
import BorderLeftBox from "../../components/boxes/BorderLeftBox"
import CardThree from "../../components/cards/CardThree"
import csrPageData from "../../data/english/subpages/csr-page-data"
import Footer from "../../layouts/Footer"
import MainHeader from "../../layouts/MainHeader"

const CSRPage = () => {
  return (
    <main className="page" id="main">
    <div className="sticky-view-two">
        <div className="sticky-container">
            <MainHeader 
                image={{
                    src : require(`../../assets/images/wallpaper/${csrPageData.headerImage.name}`),
                    alt : csrPageData.headerImage.alt,
                }}
                title=""
            />
        </div>
        <div className="sticky-container-two">
            <div className="wrapper-small">
            <h1 className="title-center">{csrPageData.mainTitle}</h1>
            <p className="text-paragraph">{csrPageData.paragraphOne}</p>
            <BorderLeftBox 
                title={csrPageData.boxOne.title}
                subtitle={csrPageData.boxOne.subtitle}
            />

            <BorderLeftBox 
                title={csrPageData.boxTwo.title}
                subtitle={csrPageData.boxTwo.subtitle}
            />
            <ScrollView>
                {csrPageData.cards.map((item, index) => (
                    <CardThree 
                        key={index}
                        title={item.title}
                        subtitle={item.subtitle}
                        list={item.list}
                    />
                ))}
            </ScrollView>
            <div className="space-50"></div>
            <div className="wrapper-small">
                <p className="text-paragraph">{csrPageData.paragraphTwo}</p>
            </div>
            <div className="space-50"></div>
            <BorderLeftBox 
                title={csrPageData.boxThree.title}
                subtitle={csrPageData.boxThree.subtitle}
            />
            <ul className="normal-list">
                {csrPageData.list.map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
            </ul>
            <p className="text-paragraph">{csrPageData.paragraphThree}</p>
            <p className="text-paragraph">To view SAB’s complete CSR Policy, visit link.</p>
            </div>
            <div className="space-50"></div>
            <div className="space-50"></div>
            <div className="space-50"></div>
            <Footer withBlogs={false} />
        </div>
    </div>
    </main>
  )
}

export default CSRPage